const AllSubscriptionStatus = [
    {
        label: 'ทุกสถานะของแพ็คเกจ',
        value: 0
    },
    {
        label: 'New',
        value: 1
    },
    {
        label: 'Active (Exist)',
        value: 2
    },
    {
        label: 'Expired (Churn)',
        value: 4
    }
]

const AllActivationStatus = [
    {
        label: 'ทุกสถานะการยืนยันตัวตน',
        value: 0
    },
    {
        label: 'ยังไม่ได้ยืนยันตัวตน',
        value: 1,
        statusGroup: [1, 2, 3, 4, 5]
    },
    {
        label: 'รอตรวจสอบ',
        value: 2,
        statusGroup: [6, 8]
    },
    {
        label: 'ต้องการข้อมูลเพิ่มเติม',
        value: 3,
        statusGroup: [7]
    },
    {
        label: 'ยืนยันตัวสำเร็จ',
        value: 4,
        statusGroup: [9]
    }
]

const AllActiveUserStatus = [
    {
        label: 'All',
        value: 'All'
    },
    {
        label: 'Active',
        value: 'Active'
    },
    {
        label: 'Inactive',
        value: 'Inactive'
    }
]

const AllBank = [
    { id: 0, label: 'ทุกธนาคาร' },
    { id: 1, logoPath: require('@/assets/bank/k-bank46x46.jpg'), label: 'ธนาคารกสิกรไทย' },
    { id: 2, logoPath: require('@/assets/bank/scb-bank46x46.jpg'), label: 'ธนาคารไทยพาณิชย์' },
    { id: 3, logoPath: require('@/assets/bank/bangkok-bank46x46.jpg'), label: 'ธนาคารกรุงเทพ' },
    { id: 4, logoPath: require('@/assets/bank/ktb-bank46x46.jpg'), label: 'ธนาคารกรุงไทย' },
    { id: 5, logoPath: require('@/assets/bank/tmb-bank46x46.jpg'), label: 'ธนาคารทหารไทย' },
    { id: 6, logoPath: require('@/assets/bank/krungsri-bank46x46.jpg'), label: 'ธนาคารกรุงศรีอยุธยา' },
    { id: 7, logoPath: require('@/assets/bank/gsb-bank46x46.jpg'), label: 'ธนาคารออมสิน' },
    { id: 8, logoPath: require('@/assets/bank/other.png'), label: 'ธนาคารอื่นๆ' },
    { id: 9, logoPath: require('@/assets/bank/thanachart-bank.png'), label: 'ธนาคารธนชาต' },
    { id: 10, logoPath: require('@/assets/bank/tisco-bank.png'), label: 'ธนาคารทิสโก้' },
    { id: 11, logoPath: require('@/assets/bank/uob-bank.png'), label: 'ธนาคารยูโอบี' },
    { id: 12, logoPath: require('@/assets/bank/kiatnakin-bank.png'), label: 'ธนาคารเกียรตินาคิน' },
    { id: 13, logoPath: require('@/assets/bank/cimb_bank.png'), label: 'ธนาคารซีไอเอ็มบีไทย' },
    { id: 14, logoPath: require('@/assets/bank/lh_bank.png'), label: 'ธนาคารแลนด์ แอนด์ เฮาส์' }
]

export {
    AllSubscriptionStatus,
    AllActivationStatus,
    AllActiveUserStatus,
    AllBank
}
